// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__h6usI","inner":"Card_inner__C3bee","img":"Card_img__qoKn9","text":"Card_text__zcarM","active":"Card_active__mo8UX","lineclamp":"Card_lineclamp__6dZgM"};